export enum ROUTES {
  LOGIN = '/login',
  EMPLOYEES = "/",
  FACILITIES = "/facilities",
  BANNERS = "/banners",
}